import React from "react";

const BellIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9476_20061"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9476_20061)">
        <path
          d="M16.6971 29.3341C15.2117 29.3341 13.9335 28.091 14.0177 26.6863H19.3097C19.4045 28.0558 18.1333 29.3341 16.6971 29.3341ZM28.015 25.3133H5.3125C5.3125 24.8954 5.3125 24.5162 5.3125 24.1369C5.33697 24.0169 5.39837 23.9077 5.48808 23.8244C6.24659 23.0588 7.01562 22.3038 7.76359 21.5278C7.88578 21.3938 7.95667 21.2209 7.96376 21.0397C7.96376 18.7571 7.96376 16.4746 7.96376 14.1886C7.91687 12.2571 8.52148 10.366 9.6802 8.81998C10.8389 7.27395 12.4843 6.16295 14.3513 5.66591C14.5972 5.59568 14.6744 5.49736 14.6604 5.25506C14.6446 5.01301 14.6446 4.7702 14.6604 4.52816C14.6931 4.0286 14.9125 3.55963 15.275 3.21435C15.6376 2.86907 16.1166 2.67275 16.6172 2.66434C17.1178 2.65594 17.6032 2.83608 17.9771 3.169C18.351 3.50192 18.586 3.96326 18.6355 4.46144C18.6583 4.73604 18.6583 5.01206 18.6355 5.28666C18.6355 5.50438 18.6987 5.59217 18.9164 5.63782C20.771 6.12671 22.4086 7.22197 23.5687 8.74923C24.7288 10.2765 25.3446 12.1479 25.3181 14.0656V20.9168C25.3104 21.0483 25.3326 21.1798 25.3831 21.3014C25.4336 21.4231 25.511 21.5317 25.6095 21.6191C26.354 22.3425 27.0867 23.0752 27.8078 23.8173C27.913 23.9393 27.9758 24.0921 27.9869 24.2528C28.036 24.6039 28.015 24.9516 28.015 25.3133Z"
          fill="#0A012E"
        />
        <path
          d="M16.6971 29.3341C15.2117 29.3341 13.9335 28.091 14.0177 26.6863H19.3097C19.4045 28.0558 18.1333 29.3341 16.6971 29.3341ZM28.015 25.3133H5.3125C5.3125 24.8954 5.3125 24.5162 5.3125 24.1369C5.33697 24.0169 5.39837 23.9077 5.48808 23.8244C6.24659 23.0588 7.01562 22.3038 7.76359 21.5278C7.88578 21.3938 7.95667 21.2209 7.96376 21.0397C7.96376 18.7571 7.96376 16.4746 7.96376 14.1886C7.91687 12.2571 8.52148 10.366 9.6802 8.81998C10.8389 7.27395 12.4843 6.16295 14.3513 5.66591C14.5972 5.59568 14.6744 5.49736 14.6604 5.25506C14.6446 5.01301 14.6446 4.7702 14.6604 4.52816C14.6931 4.0286 14.9125 3.55963 15.275 3.21435C15.6376 2.86907 16.1166 2.67275 16.6172 2.66434C17.1178 2.65594 17.6032 2.83608 17.9771 3.169C18.351 3.50192 18.586 3.96326 18.6355 4.46144C18.6583 4.73604 18.6583 5.01206 18.6355 5.28666C18.6355 5.50438 18.6987 5.59217 18.9164 5.63782C20.771 6.12671 22.4086 7.22197 23.5687 8.74923C24.7288 10.2765 25.3446 12.1479 25.3181 14.0656V20.9168C25.3104 21.0483 25.3326 21.1798 25.3831 21.3014C25.4336 21.4231 25.511 21.5317 25.6095 21.6191C26.354 22.3425 27.0867 23.0752 27.8078 23.8173C27.913 23.9393 27.9758 24.0921 27.9869 24.2528C28.036 24.6039 28.015 24.9516 28.015 25.3133Z"
          fill="#0A012E"
        /> 
      </g>
    </svg>
  );
};

export default BellIcon;
